import axios from 'axios';
import { api } from '../../../config';
import { getDeviceId } from '../../../helpers/deviceId';

// Instance sendiri (seperti authHttp di slices/auth/login/thunk.js): interceptor global
// membuang body error BE, padahal halaman ini butuh data.code untuk membedakan kasus.
const authHttp = axios.create({ baseURL: api.API_URL, withCredentials: true });

export const AUTH_ERROR_CODES = {
  notInDmut: 'NOT_IN_DMUT',
  pertaminaAccount: 'PERTAMINA_ACCOUNT',
  internalAccount: 'INTERNAL_ACCOUNT',
  alreadyRegistered: 'ALREADY_REGISTERED',
  tooManyAttempts: 'TOO_MANY_ATTEMPTS',
  invalidCode: 'INVALID_CODE',
  ticketInvalid: 'TICKET_INVALID',
  invalidPassword: 'INVALID_PASSWORD',
  emailFailed: 'EMAIL_FAILED',
  mfaExpired: 'MFA_EXPIRED',
  invalidMfaCode: 'INVALID_MFA_CODE',
};

export const getAuthErrorCode = error => error?.response?.data?.data?.code;

export const getAuthErrorMessage = error => {
  if (error?.response?.status === 429 && !error?.response?.data?.message) {
    return 'Too many requests. Please wait a minute and try again.';
  }
  if (!error?.response) {
    return 'Unable to reach the server. Check your connection and try again.';
  }
  const { message, errors } = error.response.data || {};
  const details = Array.isArray(errors) && errors.length ? errors : null;
  return details
    ? `${message || 'Request failed.'} ${details.join(' ')}`
    : message || 'Something went wrong. Please try again.';
};

const unwrap = response => response?.data?.data;

// Cek email trader ke DMUT sebelum kode dikirim; companyName sudah di-masking oleh BE.
export const checkSupplierRegistrationEmail = email =>
  authHttp
    .post('/account/supplier-registration/check-email', { email })
    .then(unwrap);

export const startSupplierRegistration = email =>
  authHttp.post('/account/supplier-registration/start', { email }).then(unwrap);

export const verifySupplierRegistrationEmail = (email, code) =>
  authHttp
    .post('/account/supplier-registration/verify-email', { email, code })
    .then(unwrap);

export const completeSupplierRegistration = payload =>
  authHttp
    .post('/account/supplier-registration/complete', payload)
    .then(unwrap);

export const verifyLoginMfa = ({ mfaToken, code, isRecoveryCode }) =>
  authHttp
    .post('/account/login-mfa', {
      mfaToken,
      code,
      isRecoveryCode: !!isRecoveryCode,
      deviceId: getDeviceId(),
    })
    .then(unwrap);
